/**
 * Parse clipboard text into OTP digits.
 *
 * Rules:
 * - Pre-slice to 100 chars to prevent main-thread jank on huge clipboard data
 * - Strip all non-numeric characters
 * - Truncate to 6 digits max
 * - Returns an array of single-char strings (may be fewer than 6 if not enough digits)
 *
 * Always rewrites from position 0, regardless of which box is focused.
 * If 0 numeric digits found, returns an empty array (caller leaves existing state unchanged).
 */
export function parseOtpFromClipboard(text: string): string[] {
  return text.slice(0, 100).replace(/\D/g, '').slice(0, 6).split('')
}

/**
 * Compute the index of the box that should receive focus after a paste.
 * Focuses the last filled box (or box 0 if nothing was pasted).
 */
export function pasteNextFocusIndex(parsedDigits: string[]): number {
  return Math.min(parsedDigits.length, 5)
}
